import { useCallback, useEffect, useRef, useState } from "react"

const useAutosizingTextarea = ({
    value,
    onChange,
    onFocus,
    onBlur,
    minimumHeight,
    maximumHeight,
    scrollHeightOffset = 0,
    overflowThreshold = 0,
}) => {
    const textareaRef = useRef(null)
    const [height, setHeight] = useState(minimumHeight)
    const [focused, setFocused] = useState(false)
    const [showScroll, setShowScroll] = useState(false)

    const resize = useCallback((target) => {
        const node = target || textareaRef.current
        if (!node) return

        const rawHeight = node.scrollHeight - scrollHeightOffset
        const hasContent = Boolean(node.value?.length)
        const nextHeight = hasContent ? Math.min(maximumHeight, Math.max(minimumHeight, rawHeight)) : minimumHeight

        setHeight(nextHeight)
        setShowScroll(rawHeight > maximumHeight + overflowThreshold)
    }, [maximumHeight, minimumHeight, overflowThreshold, scrollHeightOffset])

    useEffect(() => {
        resize()
    }, [resize, value])

    const handleChange = (event) => {
        onChange?.(event)
        resize(event.target)
    }

    const handleFocus = (event) => {
        setFocused(true)
        onFocus?.(event)
    }

    const handleBlur = (event) => {
        setFocused(false)
        onBlur?.(event)
    }

    return {
        textareaRef,
        height,
        focused,
        showScroll,
        handleChange,
        handleFocus,
        handleBlur,
    }
}

export default useAutosizingTextarea
